export default {
  notificationTitle: {
    en: 'Offer Free Product has just been applied',
  },
}
